export default __webpack_public_path__ + "static/media/sludge.a813d246.png";